import { Formik } from 'formik';

import { ButtonColors } from 'types';
import { Icon } from 'components/icon';
import { formatPrice } from 'utils/helpers';
import { isMobile, useNavigate } from 'hooks';
import { InputField } from 'components/fields';
import * as CommonStyles from 'components/styles';
import { Dialog, DialogType } from 'components/dialog';
import { Button, ButtonTypes, ButtonWithRef } from 'components/button';

import { PartialApprovedDialogProps } from './types';
import { initialValues, getValidationSchema } from './config';

export const PartialApprovedDialog = ({
  data,
  type,
  withNavigate,
  onChangeStatus,
}: PartialApprovedDialogProps) => {
  const mobile = isMobile();
  const navigate = useNavigate();
  const requestedAmount = data.requestAmount ?? data.amount;

  return (
    <Dialog
      title="Partial Approve"
      closeOnDocumentClick={false}
      trigger={
        <ButtonWithRef
          fullWidth={mobile}
          tooltip="Partial Approve"
          icon={<Icon.CoinDollarNotFilled />}
          colorType={ButtonColors.LightYellow}
        />
      }
    >
      {(close, _, ButtonWrap) => (
        <Formik
          initialValues={initialValues}
          validationSchema={getValidationSchema(requestedAmount)}
          onSubmit={async ({ amount }) => {
            const payout = await onChangeStatus(+amount);

            if (payout) {
              if (withNavigate) {
                navigate(-1);
              }
              close();
            }
          }}
        >
          {({ dirty, isSubmitting }) => (
            <CommonStyles.Form gap={24}>
              <p>
                You are about to partially approve this {type}{' '}
                <b>{formatPrice(requestedAmount)}</b>. The requested amount will
                be adjusted once the partial approval is applied.
              </p>

              <InputField
                number
                decimal
                name="amount"
                controlErrorLabel
                label="Approved Amount"
                placeholder="Add Approved Amount"
              />

              <ButtonWrap type={DialogType.Plain}>
                <Button
                  text="Cancel"
                  onClick={close}
                  colorType={ButtonColors.LightBlue}
                />
                <Button
                  text="Approve"
                  type={ButtonTypes.Submit}
                  disabled={!dirty || isSubmitting}
                  colorType={ButtonColors.LightGreen}
                />
              </ButtonWrap>
            </CommonStyles.Form>
          )}
        </Formik>
      )}
    </Dialog>
  );
};
